import { useMemo } from 'react';

import { useAtomValue } from 'jotai';

import appConfig from 'app-config';

import { userDataAtom } from 'src/stores/auth/atoms';
import getDeviceId from 'src/utils/device/id';

export default function useHelpCenterUrl(customTicketFormId?: string) {
  const userData = useAtomValue(userDataAtom);

  const resolvedTicketFormId = useMemo(() => {
    if (appConfig.serviceCode === 'azar' && customTicketFormId == null) {
      return '114093958053';
    }

    return customTicketFormId;
  }, [customTicketFormId]);

  return useMemo(() => {
    const url = new URL(appConfig.helpCenterBaseUrl);
    const userName = userData?.userProfile?.username;
    // customTicketFormId를 명시적으로 넘긴 호출(예: 밴 화면)은 로그아웃 상태라도 이동해야 하므로
    // userName 없이도 ticket_form_id를 붙인다. 기본 ticket_form_id를 쓰는 호출은 기존대로 userName이 있을 때만 이동한다.
    const canAttachWithoutUserName = customTicketFormId != null;

    if (resolvedTicketFormId && (userName || canAttachWithoutUserName)) {
      url.pathname = '/hc/requests/new';
      url.searchParams.append('ticket_form_id', resolvedTicketFormId);
      url.searchParams.append('entry.15134161430809', getDeviceId());

      if (userName) {
        url.searchParams.append('entry.38573527', userName);
      }
    }

    return url.toString();
  }, [userData, resolvedTicketFormId, customTicketFormId]);
}
